module.exports = __webpack_public_path__ + "static/media/pintinterest.512dfc5b.svg";